import { call, put, takeEvery } from 'redux-saga/effects';
import { mockCourses } from '../../../../utils/mockData';
import * as actions from './_actions';
import * as types from './_actionTypes';

function* fetchStudentDashboardSaga() {
  try {
    const mockData = {
      enrolledCourse: mockCourses[0],
      progress: {
        videosWatched: 2,
        totalVideos: 5,
        quizzesCompleted: 1,
        totalQuizzes: 5,
        assessmentsCompleted: 0,
        totalAssessments: 2,
        examStatus: 'not_started'
      },
      recentActivities: [
        { id: 1, type: 'video_watched', message: 'Completed: Programming Basics', time: '2 hours ago' },
        { id: 2, type: 'quiz_completed', message: 'Quiz completed with 85% score', time: '1 day ago' },
        { id: 3, type: 'course_enrolled', message: 'Enrolled in Computer Science course', time: '3 days ago' }
      ],
      notifications: [
        { id: 1, type: 'exam', message: 'Final exam window opens in 2 days', time: '1 hour ago', unread: true },
        { id: 2, type: 'quiz', message: 'New quiz available for Data Structures', time: '6 hours ago', unread: false }
      ]
    };
    
    yield put(actions.fetchStudentDashboardSuccess(mockData));
  } catch (error) {
    yield put(actions.fetchStudentDashboardFailure(error.message));
  }
}

function* studentDashboardSaga() {
  yield takeEvery(types.FETCH_STUDENT_DASHBOARD_REQUEST, fetchStudentDashboardSaga);
}

export default studentDashboardSaga;